/**
 * Generate base parameters for event
 * @param {HTMLElement} element - Clicked element (for click triggers; retained in signature for Phase 2 extensibility)
 * @param {Object} eventDef - Event definition from backend
 * @returns {Object|null} - Trigger-type-aware base parameters, or null for unknown trigger types
 */
export function generateEventParams(element, eventDef) {
  if (eventDef.triggerType === 'click') {
    return {
      selector: eventDef.triggerConfig.selector, // no optional chaining — guard in tracker.js guarantees this exists; TypeError here is correct behavior
      page_path: window.location.pathname,
      element_text: element?.textContent?.trim().replace(/\s+/g, ' ').substring(0, 80) ?? '' // collapse whitespace before truncating
    };
  }

  if (eventDef.triggerType === 'page_opened') {
    return {
      page_path: window.location.pathname
    };
  }

  // Unknown trigger type — warn and return null; caller must handle null and skip firing
  console.warn(`[EventFoundry] Unknown triggerType "${eventDef.triggerType}" in generateEventParams — skipping.`);
  return null;
}

export function extractMappedParams(paramMappings, triggerType) {
  if (triggerType !== 'click') return {};
  if (!paramMappings || !Array.isArray(paramMappings)) return {};

  const result = {};

  for (const mapping of paramMappings) {
    try {
      if (mapping.source !== 'dom') continue; // dataLayer deferred - skip silently

      const element = document.querySelector(mapping.selector);
      if (!element) continue;

      let value;
      if (mapping.attribute === 'textContent') {
        value = element.textContent?.trim();
      } else if (mapping.attribute === 'value') {
        value = element.value;
      } else if (mapping.attribute === 'href') {
        value = element.href;
      } else if (mapping.attribute.startsWith('data-')) {
        const dataKey = mapping.attribute.slice(5); // remove "data-"
        value = element.dataset[dataKey];
      }

      if (value != null) {
        result[mapping.paramKey] = String(value);
      }
    } catch {
      // Silently skip failed extractions
    }
  }

  return result;
}
